import React, { useEffect, useRef } from 'react';
import ECGAndPPGStrips from '../../components/ecg-ppg-strips';
import PersonalInfoBox from '../../components/personal-info-box';
import ReportHeader from '../../components/report-header';
import { drawAppendEcgChart } from '@cardiacsense/cs-charts-module';
import { RT_END_STATUS, dateFormats, print_width } from '../../consts';
import moment from 'moment';
import { fakeEcgDataForProportionSign } from '../../utils/general-utils';
import { formatEcgPpgData, getRealTimeRecordingTime } from '../../utils/ecg-ppg-utils';
import ReportFooter from '../../components/footer-report';
import '../../css/reports.css';
import RtDetailes from '../../components/rt-details';
export default function RealtimeReportComponent({ data, isPdf, width }) {
    const refToPrint = useRef(null);
    console.log('ALL DATA', data);
    const { patientProfile: patient, patientQuestions, questionsScore, af_detection_summary_data, ecg_ppg, statusRtEnd, medications } = data;
    const isAf = statusRtEnd === RT_END_STATUS.STOPPED_ECG_AF_DETECTED;
    const isDocStopped = statusRtEnd === RT_END_STATUS.STOPPED_BY_DOCTOR;
    const formattedData = formatEcgPpgData(ecg_ppg);
    const getRTRecordingTime = () => {
        var _a, _b;
        const start = (_a = ecg_ppg[0]) === null || _a === void 0 ? void 0 : _a.timestamp;
        const end = (_b = ecg_ppg[ecg_ppg.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
        const record = getRealTimeRecordingTime(start, end, dateFormats.tz);
        return record;
    };
    const record = getRTRecordingTime();
    useEffect(() => {
        drawEcgCharts(patient.fwVersion);
    }, [width]);
    const drawEcgCharts = (fwVersion) => {
        const charts = { "ecg-report-chart": { draw: drawAppendEcgChart, data: [formattedData] } };
        Object.keys(charts).forEach(type => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { draw, data } = charts[type];
            if (type === 'ecg-report-chart') {
                //this inject fake data for drawing a proportion sign
                ((_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.ecg_ppg) === null || _b === void 0 ? void 0 : _b.ecg_ppg_strips_sorted) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.strips) === null || _e === void 0 ? void 0 : _e[0]) &&
                    (data[0].ecg_ppg.ecg_ppg_strips_sorted[0].strips[0] =
                        fakeEcgDataForProportionSign(1, fwVersion));
            }
            const chartNode = document.getElementsByClassName(`${type}`)[0];
            let height = width / 4; //isPdf ? pdf_chart_height : chart_height
            const chartSVG = draw(...data, {}, (date) => window.open(`/static/reports/af-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), width, height, type, false, fwVersion);
            // draw the same chart beat smaller for printing in portal
            let chartSVGPrint;
            if (!isPdf) {
                chartSVGPrint = draw(...data, {}, (date) => window.open(`/static/reports/daily-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), print_width, print_width / 4);
            }
            function isNode(e) {
                return (typeof Node === "object" ? e instanceof Node :
                    e && typeof e === "object" && typeof e.nodeType === "number" && typeof e.nodeName === "string");
            }
            if (chartSVG.length > 1) {
                if ((_f = chartNode.children) === null || _f === void 0 ? void 0 : _f.length)
                    chartNode.innerHTML = ''; //avoid duplications
                chartSVG.map((m, index, arr) => {
                    if (isNode(m)) {
                        const wrapBrowserChart = document.createElement('div');
                        wrapBrowserChart.setAttribute('class', `${!isPdf ? 'print-hide' : ''} pdf-cut-guard`);
                        wrapBrowserChart.appendChild(m);
                        chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapBrowserChart);
                    }
                });
                if (chartSVGPrint) {
                    chartSVGPrint.map((m, index, arr) => {
                        if (isNode(m)) {
                            const wrapPrintChart = document.createElement('div');
                            wrapPrintChart.setAttribute('class', 'print-show pdf-cut-guard');
                            wrapPrintChart.appendChild(m);
                            chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapPrintChart);
                        }
                    });
                }
            }
            else {
                isNode(chartSVG) && !((_g = chartNode.children) === null || _g === void 0 ? void 0 : _g.length) && (chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(chartSVG));
            }
        });
    };
    return (React.createElement("div", { ref: refToPrint, className: `wrap-report wrap-monthly-report wrap-realtime-report ${isPdf ? 'is-pdf' : 'is-not-pdf'}` },
        React.createElement(ReportHeader, { title: 'Realtime Report', user: patient, isPdf: false, startDate: record.startFormatted, refToPrint: refToPrint }),
        React.createElement(PersonalInfoBox, { user: patient, patientQuestions: patientQuestions, questionsScore: questionsScore, medications: medications }),
        React.createElement(RtDetailes, { record: record, isAf: isAf, isStopped: isDocStopped }),
        React.createElement("div", { className: 'ecg-report-chart' },
            React.createElement(ECGAndPPGStrips, { af_detection_summary_data: af_detection_summary_data, rtDate: "09:28, 24 Oct 2022", isPdf: isPdf })),
        React.createElement(ReportFooter, null)));
}
